export const color = {
  white: '#FFF',
  silver: '#C7CCD6',
  silverDark: '#BCCBD3',
  yellow: '#FEB92C',
  blue: '#0E64E6',
  blueDark: '#081E4A',
  blueLight: '#F8FAFF',
  blueBackground: '#ECF3FE',
  landingsBackground: '#EAF1FB',
  gray: '#999',
  grayDark: '#BBC9E4',
  grayLight: '#E6E8ED',
  red: '#FF7875',
  green: '#55A495',
  blueInfo: '#00BFFF',
  font: '#081E4A',
  footerBorder: 'rgba(255, 255, 255, 0.1)',
  footerLink: 'rgba(255, 255, 255, 0.6)',
  ideaPlan: '#FFBA00',
  ideaPlanLight: '#FFF7E0',
  businessGuide: '#FF7875',
  businessGuideLight: '#FFF1F1',
  financialPlan: '#55A495',
  financialPlanLight: '#E6F5F3',
  ideaValidation: '#00BFFF',
  ideaValidationLight: '#F1FCFF',
  businessPlan: '#0A3999',
  businessPlanLight: '#EFF4FF',
  whiteboard: '#0E64E6',
  whiteboardLight: '#d9e2fc',
  advertisementBlue: '#8AB1FF',
  paleGrey: '#F3F6FC',
  backgroundHover: '#DDEAFF',
  backgroundHover2: '#EFF8FF',
  ai: '#8509F6',
}

export const breakpoint = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1440px',
  xxxl: '1920px',
}

export const transition = {
  default: 'all .2s ease-in-out',
}

export const opacity = {
  default: '0.7',
}

export const noOfIdeasBorder = {
  border: '1px solid #d3d9e1;',
}
